<template>
  <el-popover width="270" popper-class="data-bar-popper" trigger="click" placement="bottom">
    <div class="preset-colors">
      <div class="title">预设颜色</div>
      <div class="colors-wrapper">
        <div
          v-for="(item, index) in presetDataBarColors"
          :key="index"
          class="color-wrapper"
          :class="{
            active: curData.negative === item.negative && curData.positive === item.positive
          }"
          @click="changeData(item)"
        >
          <div class="item" :style="'background:' + item.positive"></div>
          <div class="item" :style="'background:' + item.negative"></div>
        </div>
      </div>
    </div>
    <div class="customize">
      <div class="title">自定义颜色</div>
      <div class="content">
        <span class="label">正值</span>
        <el-color-picker
          v-model="curData.positive"
          class="value"
          @change="changeData(curData)"
        ></el-color-picker>
        <span class="label">负值</span>
        <el-color-picker
          v-model="curData.negative"
          class="value"
          @change="changeData(curData)"
        ></el-color-picker>
      </div>
    </div>
    <div slot="reference" class="data-bar-color">
      <div
        class="item"
        :style="'background:' + (curData.positive ? curData.positive : '#fff')"
      ></div>
      <div
        class="item"
        :style="'background:' + (curData.negative ? curData.negative : '#fff')"
      ></div>
    </div>
  </el-popover>
</template>
<script>
import { presetDataBarColors } from "@/views/Backend/Admin/Statistics/chartEdit/static"
export default {
  name: "data-bar-popper",
  props: {
    curData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { presetDataBarColors }
  },
  methods: {
    changeData(item) {
      this.$emit("changeData", item)
    }
  }
}
</script>

<style lang="scss" scoped>
.data-bar-popper {
  padding: 20px;
  .title {
    margin-bottom: 10px;
  }
  .preset-colors {
    .colors-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .color-wrapper {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px;
        border: 1px solid #e9e9e9;
        cursor: pointer;
        &.active {
          box-shadow: 0 0 2px 3px #dcdfe6;
        }
        .item {
          width: 16px;
          height: 32px;
        }
      }
    }
  }
  .customize {
    .content {
      display: flex;
      align-items: center;
      .label {
        margin-right: 10px;
      }
      .value {
        margin-right: 20px;
      }
    }
  }
}
</style>
